import displayHuman from '@/mixin/displayHuman'

const TOP = 'TOP'
const BOTTOM = 'BOTTOM'

export default {
    mixins: [displayHuman],
    methods: {
        getConfigurationDatatableAssetVisionData(asset, model, data) {
            if (!asset.configuration_datatable_asset_vision_data || !asset.configuration_datatable_asset_vision_data[model]) {
                return false
            }
            let config = asset.configuration_datatable_asset_vision_data[model] ?? {}

            let result
            switch (data) {
                case 'value':
                    result = config['value_net'] ?? config['volume_net']
                    break
                case 'min':
                    result = config['value_min'] ?? 0
                    break
                case 'max':
                    result = config['value_max'] ?? config['volume_max']
                    break
                case 'percent':
                    if (config['percent']) {
                        result = config['percent']
                    } else if (config['value_net'] && config['value_max']) {
                        result = (config['value_net'] * 100) / config['value_max']
                    } else if (config['volume_net'] && config['volume_max']) {
                        result = (config['volume_net'] * 100) / config['volume_max']
                    }
                    break
                case 'unit':
                    result = config['unit'] ?? 'L'
                    break
                default:
                    result = config[data] ?? '-'
            }

            return typeof result === 'number' ? this.displayToHumanNumberWithSpace(result) : result
        },

        /**
         * `offset` only matters for sensors at the top of the equipment, `offset_bottom` for those at the bottom.
         * An unknown position (no device, no referential, position not set) keeps both fields.
         *
         * @param {import('@/models/IDevice').IDevice[] | undefined} devices
         * @returns {string[]}
         */
        getHiddenOffsetKeys(devices) {
            if (!devices || devices.length === 0) {
                return []
            }

            const positions = devices.map((device) => device.device_referentiel?.sensor_position ?? null)
            const hiddenKeys = []
            if (positions.every((position) => position === BOTTOM)) {
                hiddenKeys.push('offset')
            }
            if (positions.every((position) => position === TOP)) {
                hiddenKeys.push('offset_bottom')
            }

            return hiddenKeys
        },
    },
}
